/* ------------------------------------------------------------------
   rb-klaviyo-capture.js
   Inline email capture for article bodies -> Klaviyo list, no page reload.

   WHY THIS LIVES IN THE THEME AND NOT IN THE ARTICLE BODY:
   Shopify's rich-text article editor strips <script> tags on save. An inline
   handler in the article body works until the first time anyone opens that
   article in the admin editor and hits save — then it silently disappears and
   the form degrades to a native submit (page reload, no signup, no report).
   That happened to the Women & AI post on 2026-09-28. Keeping the handler here
   makes it survive every future edit.

   HOW TO USE IT IN AN ARTICLE BODY (plain HTML, no script needed):

     <form class="wai__form" data-klaviyo-capture data-list-id="XS6zjX"
           data-event="Requested Women and AI Report"
           data-source="Women & AI Report — blog">
       <input type="email" name="email" required>
       <button type="submit">Send it to me</button>
     </form>
     <p data-klaviyo-msg></p>
     <div data-klaviyo-done hidden> ...thank-you + download link... </div>

   Legacy ids (#wai-form / #wai-msg / #wai-done) are also recognised so the
   existing Women & AI markup keeps working untouched.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var COMPANY_ID = 'PLHsNG';           // Klaviyo public site key for rosewoman.com
  var REVISION   = '2024-10-15';
  var ENDPOINT   = 'https://a.klaviyo.com/client/subscriptions/';

  function byId(id) { return document.getElementById(id); }

  function wire(form) {
    if (!form || form.dataset.rbWired === '1') { return; }
    form.dataset.rbWired = '1';

    var listId = form.getAttribute('data-list-id') || 'XS6zjX';
    var evt    = form.getAttribute('data-event')   || '';
    var source = form.getAttribute('data-source')  || 'Article inline capture';

    var input = form.querySelector('input[type="email"]');
    var btn   = form.querySelector('button[type="submit"], button');
    var msg   = form.parentNode.querySelector('[data-klaviyo-msg]') || byId('wai-msg');
    var done  = form.parentNode.querySelector('[data-klaviyo-done]') || byId('wai-done');
    if (!input) { return; }

    var label = btn ? btn.textContent : '';

    function say(text, isError) {
      if (!msg) { return; }
      msg.className = isError ? 'wai__msg wai__msg--err' : 'wai__msg';
      msg.innerHTML = text;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      say('', false);

      if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
        say('Please enter a valid email address.', true);
        input.focus();
        return;
      }

      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      var props = {};
      if (evt) { props[evt] = true; }

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(COMPANY_ID), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).then(function (r) {
        if (r.status === 202 || r.ok) {
          form.style.display = 'none';
          say('', false);
          if (done) { done.hidden = false; done.style.display = 'block'; }
          if (window._learnq && evt) {
            window._learnq.push(['track', evt, { Email: email }]);
          }
        } else {
          throw new Error('status ' + r.status);
        }
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        // fallback: explicit attribute, else the first link inside the thank-you block
        var fallback = form.getAttribute('data-fallback-url');
        if (!fallback && done) {
          var a = done.querySelector('a[href]');
          if (a) { fallback = a.getAttribute('href'); }
        }
        say(
          'Something went wrong on our end.' +
          (fallback ? ' You can <a href="' + fallback + '" target="_blank" rel="noopener">open it directly</a>.' : ' Please try again in a moment.'),
          true
        );
      });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-klaviyo-capture]');
    for (var i = 0; i < forms.length; i++) { wire(forms[i]); }
    wire(byId('wai-form'));   // legacy markup
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
